var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"projects"},[_c('Library',{attrs:{"data":_vm.data}}),_vm._v(" "),_c('FaPreFooter',{attrs:{"title":_vm.$c.text('pages.projects.preFooterTitle'),"description":_vm.$c.text('pages.projects.preFooterDescription'),"button-title":_vm.$c.text('button.start-now'),"columns":"col-6","class-name":"projects-pre-footer"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }